import { URLS } from 'constants/api.constants';
import { axiosInstance } from 'utils/axios';

const { createAsyncThunk } = require('@reduxjs/toolkit');

export const emailSubscribe = createAsyncThunk(
  'email/subscribe',
  async ({ email }, { rejectWithValue }) => {
    try {
      const response = await axiosInstance.post(URLS.EMAIL_SUBSCRIPTION, {
        email,
      });
      if (response?.data?.success) {
        return response.data;
      }
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);
